(() => {
  function mount(root=document) {
    root.querySelectorAll('[data-catalog-kafe]').forEach(section => {
      if(section.dataset.catalogMounted) return;
      section.dataset.catalogMounted='true';
      const grid=section.querySelector('[data-catalog-products]');
      const items=[...section.querySelectorAll('[data-catalog-item]')];
      const query=section.querySelector('[data-catalog-query]');
      const sort=section.querySelector('[data-catalog-sort]');
      const available=section.querySelector('[data-catalog-available]');
      const filters=section.querySelector('[data-catalog-filters]');
      const normal=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('pt-BR').trim();
      function update() {
        const term=normal(query.value);
        const ordered=[...items];
        if(sort.value==='price-asc') ordered.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
        if(sort.value==='price-desc') ordered.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
        if(sort.value==='title') ordered.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title,'pt-BR'));
        let count=0;
        ordered.forEach(item=>{
          item.hidden=!normal(item.dataset.title).includes(term)||(available.checked&&item.dataset.available!=='true');
          if(!item.hidden) count++;
          grid.append(item);
        });
        section.querySelector('[data-catalog-count]').textContent=count+' '+(count===1?'café':'cafés');
        section.querySelector('[data-catalog-empty]').hidden=count>0;
      }
      function reset(){query.value='';sort.value='featured';available.checked=false;update();}
      query.addEventListener('input',update);sort.addEventListener('change',update);available.addEventListener('change',update);
      section.querySelector('[data-catalog-reset]').addEventListener('click',reset);
      section.querySelector('[data-catalog-clear]').addEventListener('click',()=>{reset();filters.open=true;query.focus();});
      filters.addEventListener('keydown',e=>{if(e.key==='Escape'){filters.open=false;filters.querySelector('summary').focus();}});
      filters.hidden=false;
      update();
    });
  }
  mount();
  document.addEventListener('shopify:section:load',e=>mount(e.target.parentElement));
})();
